// import Vue from 'vue'
import { AMEND_BAR, AMEND_CATEGORY, AMEND_VISIBLE } from "../type";
export default{
  state:{
    barActive:0,
    category:String,
    centerDialogVisible:false,
  },
  mutations:{
    //商品列表
    [AMEND_BAR](state,data){
      state.barActive= data
    },
    // 修改类别状态
    [AMEND_CATEGORY](state,data){
      state.category = data
    },
    // 修改详情页显示状态
    [AMEND_VISIBLE](state,data){
      state.category = data
    }
  },
  actions:{
    //shops
    //获取商品信息
    async barAmend({commit},i){
      commit(AMEND_BAR,i)
    },
    // 修改类别状态
    release({commit},i){
      commit(AMEND_CATEGORY,i)
    },
    // 修改详情页显示状态
    visible({commit},i){
      commit(AMEND_VISIBLE,i)
    }
  }
}